import { Card, CardBody, Col } from "reactstrap";
import { H4 } from "../../../../../AbstractElements";
import { ordersAndProfitData } from "../../../../../Data/Widgets/GeneralWidgetsData";
import ReactApexChart from "react-apexcharts";

const OrderWidgets = () => {
  return (
    <>
      {ordersAndProfitData.map((data, i) => (
        <Col sm="6" key={i}>
          <Card className="widget-1 widget-with-chart mb-xl-0">
            <CardBody>
              <div>
                <H4 className="mb-1">{data.count}</H4>
                <span className="f-light">{data.title}</span>
              </div>
              <div className={`${data.class}-chart`}>
                <ReactApexChart options={data.chart} series={data.chart.series} type={data.chart.chart?.type} height={data.chart.chart?.height} />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default OrderWidgets;
